import { appBar, theme } from "../../../utils/theme";

export const styles = {
  actionButton: {
    background: theme.palette.primary.linearGradient,
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  margin: {
    display: "flex",
    margin: 1,
  },
  selectContainer: {
    display: "flex",
    position: "relative",
  },
  selectFormIcon: {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    justifyContent: "flex-start",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      color: theme.palette.grays[400],
    },
  },
  selectMenu: {
    alignItems: "flex-start",
    borderColor: theme.palette.grays[300],
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 0,
    boxShadow: "0 0 24px rgba(37,43,129,.04), 0 44px 74px rgba(37,43,129,.06)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    pb: 0,
    pt: 2,
  },
  selectMenuContainer: {
    pb: 4,
    pt: `calc(${(appBar.height * 1) / 3}px)`,
    position: "absolute",
    left: -40,
    top: `calc(${(appBar.height * 2) / 3}px + 1px)`,
    minWidth: 300,
    zIndex: 0,
  },
  selectOption: {
    alignItems: "center",
    color: theme.palette.secondary.main,
    display: "flex",
    fontSize: theme.typography.fontSize * 0.72,
    fontWeight: 500,
    justifyContent: "flex-start",
    mb: 2,
    pb: 2,
    pl: 6,
    pr: 6,
    pt: 2,
    transition: "all 0.3s ease-in-out",
    width: 200,
    "&:hover": {
      backgroundColor: theme.palette.grays["white"],
      color: theme.palette.primary.main,
    },
  },
  selectOptionImage: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    borderRadius: 1,
    height: 32,
    mr: 3,
    width: 32,
  },
  selectOptionLabel: {
    fontSize: theme.typography.fontSize * 0.88,
    marginRight: 2,
    whiteSpace: "nowrap",
  },
  selectOptionLabelActive: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
};
